import { useSelector } from 'react-redux';
import { get, merge, set } from 'lodash';

import { ReservCell } from 'entities/Reservations';
import { authSelector } from 'modules/auth/containers/Auth/selectors';
import moment from 'moment';
import { INITIAL_VALUE } from '../BookingModal.config';
import { branchTitleSelector } from '../../LogoutBtn/selectors';

export const fillNullable = (data: any, fields: string[]) => {
  fields.forEach((field) => {
    const val = get(data, field);

    if (!val) {
      const initVal = get(INITIAL_VALUE, field);
      set(data, field, initVal);
    }
    return data;
  });
};

export const usePrepareBook = (values: any, bookCell: ReservCell | null) => {
  if (!bookCell) return {};
  const branch = useSelector(branchTitleSelector);

  const auth = useSelector(authSelector);
  const { bookingDate, id } = bookCell;
  const checkOutDate = moment(bookingDate).add(branch?.cellSetting?.slotDurationInMinutes, 'minutes');
  const data = merge({}, INITIAL_VALUE, values);

  fillNullable(data, [
    'orders',
    'reservationOwner',
    'company',
    'company.contactPerson',
    'company.contactPerson.phone',
    'company.contactPerson.phone.number',
    'company.contactPerson.email.address',
  ]);

  set(data, 'checkOutDate', values?.checkOutDate ? values?.checkOutDate : checkOutDate.format('YYYY-MM-DDTHH:mm:SS'));
  set(data, 'checkInDate', values?.checkInDate ? values?.checkInDate : bookingDate);
  set(data, 'bookingDate', values?.bookingDate ? values?.bookingDate : bookingDate);

  set(data, 'cellSettingId', branch.cellSetting?.id);
  set(data, 'branchId', branch.id);
  if (values?.reservationOwner?.name === undefined) {
    set(data, 'reservationOwner.name', auth.account?.username);
  } else {
    set(data, 'reservationOwner.name', values?.reservationOwner?.name);
  }

  set(data, 'bookCellId', id);

  return data;
};
